import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { USERS_API_TOKEN } from '@epicuro-next/data/users';

@Injectable()
export class ForgotPasswordService {
  constructor(
    private http: HttpClient,
    @Inject(USERS_API_TOKEN) private url: string,
  ) {}

  public request(username: string) {
    return this.http.post(`${this.url}/password/reset`, {
      userId: username,
    });
  }
}
